import { useEffect, useRef } from 'react';
import { getDecodedWeaveToken, getUser, isWeaveUser } from '@frontend/auth-helpers';
import { useAppScopeStore } from '@frontend/scope';
import { useAppFlagStore } from '@frontend/shared';
import { initThirdPartyScriptReady, userIdentityChanged } from './app-lifecycle-subjects';

export const useThirdPartyScripts = () => {
  const user = getUser();
  const { customizationFlags } = useAppFlagStore();
  const { selectedLocationIds, selectedGroupId } = useAppScopeStore();
  const locationId = selectedLocationIds[0] ?? '';

  const doWhenDocumentReady = (action: () => void) => {
    if (document.readyState === 'complete') {
      action();
    } else {
      window.addEventListener('load', () => {
        action();
      });
    }
  };

  useDidMount(() => {
    doWhenDocumentReady(initThirdPartyScriptReady.notify);
  });

  useEffect(() => {
    doWhenDocumentReady(() => {
      if (
        locationId !== '' &&
        user &&
        customizationFlags[locationId] &&
        !!selectedGroupId &&
        selectedLocationIds?.length > 0
      ) {
        userIdentityChanged.notify({
          user,
          decodedWeaveToken: getDecodedWeaveToken(),
          isWeaveUser: isWeaveUser(),
          locationId,
          customizationFlags: [...customizationFlags[locationId].values()],
          selectedGroupId,
          hasMultipleLocationsSelected: selectedLocationIds.length > 1,
          selectedLocationIds,
        });
      }
    });
  }, [
    user?.userID,
    getDecodedWeaveToken,
    isWeaveUser,
    locationId,
    customizationFlags,
    selectedGroupId,
    selectedLocationIds,
  ]);
};

function useDidMount(fn: () => void) {
  const once = useRef(true);

  useEffect(() => {
    if (once.current) {
      fn();
      once.current = false;
    }
  }, []);
}
